import { Pipe, PipeTransform } from '@angular/core';

import { IArticle } from '../../prisma-xs/models/article.model';
import { IsProductDeprecatedPipe } from '../../ui/pipes/is-product-deprecated.pipe';

@Pipe({
    name: 'activeProducts',
    standalone: false
})
export class ActiveProductsPipe implements PipeTransform {

  transform(articles: IArticle[]): IArticle[] {
    const deprecatedPipe = new IsProductDeprecatedPipe();
    return articles?.filter(a => !(deprecatedPipe.transform(a?.status)));
  }
}
